import { IconCheck as TablerIconCheck } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconCheck = /*#__PURE__*/ createOutlineIcon(TablerIconCheck, 'IconCheck');
